import * as yup from 'yup';

export const AvailableBedsSchema = yup.object({
  number: yup.number().required().moreThan(0),
  dateFrom: yup.string().required(),
});

export interface IAvailableBeds {
  number: number;
  dateFrom: string;
}
